import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

export const VAT_RATES_QUERY_KEY = 'company-vat-rates';

export interface VatRates {
  ticketVatRate: number | null;
  bottleServiceVatRate: number | null;
  passVatRate: number | null;
}

const getCompanyVatRates = async ({ companyId }: { companyId: string }) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/companies/${companyId}/vat-rates`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetCompanyVatRates = ({
  companyId,
  options,
}: {
  companyId: string;
  options?: Record<string, boolean>;
}) => {
  return useGenericQuery<VatRates, RequestError>(
    [VAT_RATES_QUERY_KEY, companyId],
    () => getCompanyVatRates({ companyId }),
    options,
    true
  );
};
